export class HandoverRejectedError extends Error {
  override name = "HandoverRejectedError"
}

const asRecord = (value: unknown): Record<string, unknown> | undefined =>
  typeof value === "object" && value !== null ? value as Record<string, unknown> : undefined

export const getHandoverErrorMessage = (error: unknown, fallback: string) => {
  const source = asRecord(error)
  const body = asRecord(asRecord(source?.response)?.data)
  // data 可能是诊断分类；优先展示业务说明，而不是 Axios 的 HTTP 状态说明。
  for (const message of [body?.msg, body?.message, source?.msg, source?.message]) {
    if (typeof message === "string" && message.trim()) return message.trim()
  }
  return fallback
}

export const isHandoverBusinessFailure = (value: unknown) => {
  const body = asRecord(value)
  // -1 是共享请求封装产生的超时/中止结果，不能据此认定服务端回滚。
  return typeof body?.code === "number" && Number.isInteger(body.code) && body.code > 0
}

export const toHandoverRequestError = (error: unknown): unknown => {
  if (error instanceof HandoverRejectedError) return error
  const response = asRecord(asRecord(error)?.response)
  // 网关失败不能证明上游事务失败，即使网关沿用了业务错误包装。
  if ([408, 502, 503, 504].includes(Number(response?.status))) return error
  const body = asRecord(response?.data)
  return isHandoverBusinessFailure(body)
    ? new HandoverRejectedError(getHandoverErrorMessage(error, "交班未完成，请更新统计后重新核对"))
    : error
}
